import styled from 'styled-components';

const DesktopMenuContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;

  button p {
    color: white;
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    text-transform: capitalize;
  }

  .simple-menu-container,
  .solutions-menu-container,
  .resources-menu-container {
    display: flex;
    align-items: center;
    position: relative;
  }

  .simple-menu-modal {
    width: max-content;
  }
`;

const DesktopMenuItems = styled.div`
  display: flex;
  align-items: center;
`;

export { DesktopMenuContainer, DesktopMenuItems };
